import React, { useState } from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text1, Text4 } from '../../../styles';
import { alertify, handleApiExceptions, goTo } from '../../../app_methods';
import { BulkUploadBatch } from '../../../models';
import { MerchantService } from '../../../services';
import { BulkUploadForm, OTPModal } from '../../Common';
import { ErrorModal } from './error_modal';
import { BATCHTYPES, bulkOperationsTypeMaster } from './constants';
import { bulkOperationsTemplateMaster } from './constants';
import FileSaver from 'file-saver';
import { Icon, Select } from 'antd';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../redux/actions';
import _ from 'lodash';


const batch = new BulkUploadBatch();

const BulkUploadModalComponent = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [showOTPModal, setShowOTPModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [uploadType, setUploadType] = useState(props.type)

    const downloadTemplate = async () => {
        const response = await BulkUploadBatch.downloadTemplate({ batch_type: uploadType });
        if (!response) {
            handleApiExceptions("Something went wrong !");
            return;
        }
        FileSaver.saveAs(response.data, bulkOperationsTemplateMaster[uploadType]);
    };

    const validateBulkUpload = async () => {
        setIsLoading(true);
        const response = await batch.validate({ key: props.current_user.key, batch_type: uploadType });
        if ([401, 500].includes(response.status)) {
            setIsLoading(false);
            handleApiExceptions(response.message);
            return
        }
        if (!response.success) {
            setIsLoading(false);
            if (typeof (response.message) == "string") {
                handleApiExceptions(response.message);
                return;
            }
            if (response.message) {
                setValidationErrors(response.message.errors);
                toggleErrorModal();
                return;
            }
        }
        setIsLoading(false);
        if (props.type == "transfer" && !props.current_user.bpo) {
            toggleOTPModal();
            generateBulkUploadOTP();
            return;
        }
        processBatch(uploadType);
    };

    const generateBulkUploadOTP = () => {
        setIsLoading(true);
        MerchantService.generate_otp({
            type: "bulk_transfer",
            name: batch.name,
            send_email: true,
            send_sms: true
        }).then((response) => {
            if (response.success) {
                setIsLoading(false);
            }
            else {
                setIsLoading(false);
                handleApiExceptions("OTP generation failed.");
            }
        }).catch((error) => {
            setIsLoading(false);
            handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
        });
    };

    const verifyOTP = (otp) => {
        setIsVerifying(true);
        MerchantService.verify_otp({ otp }).then((response) => {
            if (response.success) {
                if (response.data.verified) {
                    toggleOTPModal();
                    processBatch(uploadType);
                }
                else handleApiExceptions("OTP is incorrect.");
            }
            else handleApiExceptions("OTP verification failed.");
            setIsVerifying(false);
        }).catch((error) => {
            setIsVerifying(false);
            handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
        });
    };

    const processBatch = async (batch_type) => {
        setIsLoading(true);
        const response = await batch.process({ key: props.current_user.key });
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response.message.errors,"Something went wrong.");
            // Work on display or error !
            return;
        }
        alertify(
            "Success",
            "Bulk Operation created successfully. It will be processed in about 30 minutes. You can check the status of this bulk operation under Bulk Operations section.",
            "confirm",
            {
                closable: true,
                cancelText: "Close",
                okText: "Go to Bulk Operations",
                onOk: () => goTo(`/batches/${batch_type}`, props.history),
                onCancel: () => { },
                icon: <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
            }
        );
        setIsLoading(false);
        props.toggleBulkUploadModal();
        props.onSuccess();
    };

    const toggleOTPModal = () => {
        setShowOTPModal(!showOTPModal);
    };

    const toggleErrorModal = () => {
        setShowErrorModal(!showErrorModal);
    };

    const handleOnCancel = () => {
        setUploadType(props.type) 
        props.toggleBulkUploadModal()
    }


    return (
        <EaseModal
            width={350}
            title={false}
            visible={props.visible}
            onCancel={handleOnCancel}
            centered
            hideFooter
            destroyOnClose
        >
            <Text1 className="d-block mb-2" strong>{bulkOperationsTypeMaster[props.type]}</Text1>
            {props.showBatchType? 
            <div className='mt-2'>
                <Text1 className="d-block mb-2" strong>{props.bulkUploadModalType}</Text1>
                <Text4 className='d-block mt-2' strong>Select batch type:</Text4>
                <Select placeholder="Select batch type" className='w-100' onChange={(e)=>setUploadType(e)}>
                {BATCHTYPES.map((batch) => {
                    return (
                        props.current_user && props.current_user[batch.required_setting] &&
                        props.current_user.user.permissions.includes(batch.required_permission) &&
                            <Select.Option value={batch.value}>
                                <div className="d-flex">
                                    <Text4 className="mr-1">{batch.key}</Text4>
                                </div>
                            </Select.Option>
                        )
                    })
                }
                    </Select>
                    {!uploadType? null : <Text4 className="d-flex justify-content-end mt-1 mb-2" type="secondary"><a onClick={downloadTemplate} className="color-link">Download Template</a></Text4>}
                </div>:
            <Text4 className="d-block mt-1 mb-2" type="secondary"><a onClick={downloadTemplate} className="color-link">Click here</a> to download "{bulkOperationsTypeMaster[props.type]}" excel file template.</Text4>
        }
            <BulkUploadForm
                onSubmit={(values) => {
                    batch.set(values);
                    validateBulkUpload();
                }}
                loading={isLoading}
                submitText="Upload"
                batch_type={uploadType}
                merchant={props.current_user}
            />
            <ErrorModal
                visible={showErrorModal}
                toggleErrorModal={toggleErrorModal}
                errors={validationErrors}
            />
            <OTPModal
                visible={showOTPModal}
                onCancel={toggleOTPModal}
                verifyOTP={verifyOTP}
                loading={isVerifying}
                generateOTP={generateBulkUploadOTP}
            />
        </EaseModal>
    )
};

BulkUploadModalComponent.defaultProps = {
    bulkUploadModalType: '',
    type:'',
    showBatchType:false,
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

const BulkUploadModal = connect(mapStateToProps, mapDispatchToProps)(BulkUploadModalComponent);
export { BulkUploadModal };